exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[data-v-0684bc0b] {\n  word-wrap: normal;\n}\n.boards[data-v-0684bc0b] {\n  padding: 20px;\n  margin: 10px;\n  background-color: #f5f7fa;\n  width: 650px;\n}\n.el-select[data-v-0684bc0b] {\n  width: 500px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0684bc0b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roleSpecific/ExecutiveBoardMemberMenu.vue
// module id = rELm
// module chunks = 1